export const API_OPTIONS = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJhODFjYzUyZmFjMzUyYWQ0NzAwZGI3MTdlNjM4OTcyZSIsInN1YiI6IjY1ZDlhYTQxZmNiOGNjMDE4NmNiMmE1YiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.0SCSKfq4IqNdtIsZBoAK7z3FSqQPGd_NZCVFNPFFikY' 
    }
  };

  export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500";

  export const BG_URL="https://assets.nflxext.com/ffe/siteui/vlv3/c0b69670-89a3-48ca-877f-45ba7a60c16f/2642e08e-4202-490e-8e93-aff04881ee8a/IN-en-20240212-popsignuptwoweeks-perspective_alpha_website_large.jpg"

  export const SUPPORTED_LANGUAGES = [
    { identifier: "en", name: "English" },
    { identifier: "hindi", name: "Hindi" },
    { identifier: "spanish", name: "Spanish" },
  ];

  export const OPENAI_KEY="sk-proj-FqotUtVGPiqRRvwtutOCT3BlbkFJtGNruMtsFODKT1ua3jcb";


  //NEED TO  BUY THE PRO VERSION OF GPT TO USE ITS API, AND GET THE RECOMMENDED MOVIES FROM PROMT.
  